export const adminConfig = {
  appVersion: import.meta.env.VITE_APP_VERSION || "dev",
  // Demo identity/data are available only from a Vite development build. All
  // deployed builds load the principal from the HttpOnly session cookie API.
  demoMode: import.meta.env.DEV && import.meta.env.VITE_ADMIN_DEMO === "true",
};
